import {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {FlatOffer} from '../core/_models'
import {getOffers} from '../core/_requests'
import {Columns} from './columns/_columns'
import {Modal} from '@/components/table/modal/Modal'
import {FilterForm, initialFilters} from './components/FilterForm'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {OfferForm} from './components/OfferForm'
import {PricingForm} from './components/PricingForm'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

/**
 * Toolbar buttons
 */
const buttons: Array<ButtonProps> = [{
  label: 'Payment Methods',
  className: 'btn btn-danger me-3',
  icon: {
    name: 'setting-4',
    className: 'fs-2'
  },
  openModal: 'paymode'
}]


/**
 * Modal wrapper to manage open modal
 */
const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  let offer

  if (action === 'edit') {
    offer = itemForUpdate as FlatOffer
  }
  return (
    <>
      {itemForUpdate === null && action === 'paymode' && (
        <Modal title="Payment methods">
          <PricingForm />
        </Modal>
      )}

      {offer !== undefined && action === 'edit' && (
        <Modal title={`${offer.label} ${offer.country} ${offer.offer.amount} ${offer.offer.currency}`}>
          <OfferForm />
        </Modal>
      )}
    </>
  )
}


const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Pricing</PageTitle>
    <TableWrapper
      dataProvider={getOffers}
      cols={Columns}
      queryId="P2C_PRICING_LIST"
      lookup={{placeholder: 'Search Pricing'}}
      modals={ModalWrapper}
      buttons={buttons}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
    />
  </>
)

export default ListWrapper
